<div id="scoring-results">
  @if ((scoringStatus$ | async) === 'sending') {
    <div>
      <mat-progress-spinner
        class="scoring-spinner"
        color="primary"
        mode="indeterminate"
        diameter="100"
        strokeWidth="8"
        aria-label="Sending to Scoring">
      </mat-progress-spinner>
      <div class="title">Sending to Scoring</div>
    </div>
  }

  @if ((scoringStatus$ | async) === 'processing') {
    <mat-card appearance="outlined">
      <eca-app-alert
        icon="check_circle"
        type="success"
        text="Your documents have been successfully scanned and sent to be scored.  Reports are currently being generated.">
        <button mat-raised-button color="primary" ecaThrottleClick (throttleClick)="backToScanning()">Back to Scanning
        </button>
      </eca-app-alert>
    </mat-card>
  }
</div>
